import { ActiveLayout } from "models/active-layout";
export const activeLayout = new ActiveLayout();
